import elections from "./elections";

/**
 * Fetch the race data from the event for the given widget.
 *
 * @param {string} eventId
 * @param {string} widgetId
 * @returns {Object[]} The race results data
 */
export async function fetchRaceData(eventId, widgetId) {
  const result = await elections.get(`/events/${eventId}/`, {
    params: {
      filterRacesByWidgetId: widgetId
    }
  });

  return result.data.races;
}
